module.exports = __webpack_public_path__ + "static/media/pos-kelava.cf359a10.jpg";